import { Link } from 'react-router-dom';

interface CategoryHeroProps {
  name: string;
  description: string;
  coverImage: string;
  articleCount: number;
}

export default function CategoryHero({ name, description, coverImage, articleCount }: CategoryHeroProps) {
  return (
    <section className="relative min-h-[320px] md:min-h-[400px] flex items-end overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-accent-100/25 to-secondary-100/35"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-8 md:pb-12">
        <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-12">
          <div className="lg:w-[55%] space-y-4">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 text-xs text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-sm w-4 h-4 flex items-center justify-center"></i>
              返回首页
            </Link>
            <div className="flex items-center gap-3">
              <span className="px-3 py-1.5 rounded-full bg-accent-500/15 text-accent-600 text-xs font-semibold whitespace-nowrap">
                分类
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{articleCount} 篇文章</span>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-900 leading-tight tracking-tight">
              {name}
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
              {description}
            </p>
          </div>

          <div className="lg:w-[45%]">
            <img
              src={coverImage}
              alt={name}
              className="w-full h-40 md:h-56 object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}